<template>
    <div class="remarkable">
        <b-row>
            <b-col cols="6">
                <div class="title flex">
                    Remarkable
                    <div class="red mr-2">*</div>
                    <small
                        v-if="
                            !this.value.stack_able &&
                            !this.value.non_stack_able &&
                            !this.value.rotatable
                        "
                        class="text-danger"
                        >Please select at least one checkbox.</small
                    >
                </div>
            </b-col>
        </b-row>
        <b-card class="b-card-bg">
            <b-row class="px-2 custom-row">
                <b-col cols="6" lg="2">
                    <div class="container-checkbox">
                        <input
                            :disabled="readonly"
                            type="checkbox"
                            class="custom-checkbox-new"
                            v-model="value.stack_able"
                            @change="handleChange(1)"
                        />

                        <div>
                            <div class="text-black">Stackable</div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6" lg="2">
                    <div class="container-checkbox">
                        <input
                            :disabled="readonly"
                            type="checkbox"
                            class="custom-checkbox-new"
                            v-model="value.non_stack_able"
                            @change="handleChange(2)"
                        />

                        <div>
                            <div class="text-black">Nonstackable</div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6" lg="2">
                    <div class="container-checkbox">
                        <input
                            :disabled="readonly"
                            type="checkbox"
                            class="custom-checkbox-new"
                            v-model="value.rotatable"
                            @change="handleChange(3)"
                        />

                        <div>
                            <div class="text-black">Rotatable</div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6" lg="2">
                    <div class="container-checkbox">
                        <input
                            :disabled="readonly"
                            type="checkbox"
                            class="custom-checkbox-new"
                            v-model="value.oversize"
                        />

                        <div>
                            <div class="text-black">Oversize</div>
                            <div>Length>4m/package</div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6" lg="2">
                    <div class="container-checkbox">
                        <input
                            :disabled="readonly"
                            type="checkbox"
                            class="custom-checkbox-new"
                            v-model="value.overweight"
                        />

                        <div>
                            <div class="text-black">Overweight</div>
                            <div>>3tons/package</div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row> </b-row>
        </b-card>
    </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import { BRow, BCol, BCard } from "bootstrap-vue";
export default {
    components: {
        Select2,
        ValidationProvider,
        ValidationObserver,
        BRow,
        BCol,
        BCard,
    },
    props: {
        value: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            R: true,
        };
    },
    computed: {
        ...mapState("masterData", [
            "service_types",
            "ports",
            "incoterms",
            "cont_types",
            "goods_types",
            "transport_types",
            "deports_locations",
            "deports",
            "business_types",
            "customs_types",
            "shipping_lines",
            "regions",
            "companyItems",
            "fee_types",
            "handed_types",
        ]),
    },
    methods: {
        handleChange(checkboxNumber) {
            if (
                (this.value.rotatable || this.value.non_stack_able) &&
                checkboxNumber === 1
            ) {
                this.value.stack_able = true;
                this.value.non_stack_able = false;
                this.value.rotatable = false;
            } else if (
                (this.value.stack_able || this.value.rotatable) &&
                checkboxNumber === 2
            ) {
                this.value.non_stack_able = true;
                this.value.stack_able = false;
                this.value.rotatable = false;
            } else if (
                (this.value.non_stack_able || this.value.stack_able) &&
                checkboxNumber === 3
            ) {
                this.value.rotatable = true;
                this.value.stack_able = false;
                this.value.non_stack_able = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.remarkable {
    label {
        color: #000000;
        font-weight: 600;
    }
    .b-card-bg {
        height: 100px;
        @media (max-width: 992px) {
            height: 200px;
        }
        .custom-row {
            display: flex;
            // grid-template-columns: repeat(5, 1fr);
            justify-content: space-around;
            align-items: center;
            gap: 10px; /* Khoảng cách giữa các thẻ */
            @media (max-width: 992px) {
                height: 150px;
                gap: 0px;
                justify-content: unset;
            }
        }
        .container-checkbox {
            display: flex;
            gap: 5px;
            justify-items: center;
            align-items: center;
        }
        .text-black {
            color: #000000;
            font-weight: 600;
        }
    }
    //   .select2 {
    //     height: 28px !important;
    //   }
}
</style>
